import { render, staticRenderFns } from "./SerialDetails.vue?vue&type=template&id=744c6aca"
import script from "./SerialDetails.vue?vue&type=script&lang=js"
export * from "./SerialDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports